import ExcelJS from "exceljs";
import dayjs from "dayjs";

export const toAppointmentDate = (value) => {
  if (!value) return null;
  const calendarDate = (year, month, day) => {
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
      ? date : null;
  };
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : calendarDate(value.getUTCFullYear(), value.getUTCMonth() + 1, value.getUTCDate());
  }
  if (typeof value?.toDate === "function") return toAppointmentDate(value.toDate());
  if (typeof value === "object") {
    const seconds = value.seconds ?? value._seconds;
    return Number.isFinite(seconds) ? toAppointmentDate(new Date(seconds * 1000)) : null;
  }
  if (typeof value !== "string") return null;
  const text = value.trim();
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/);
  if (iso) return calendarDate(Number(iso[1]), Number(iso[2]), Number(iso[3]));
  const uk = text.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (uk) return calendarDate(Number(uk[3]), Number(uk[2]), Number(uk[1]));
  return null;
};


export async function exportAdviserAppointmentsExcel(advisers = []) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Rosemount Staff Portal";
  workbook.created = new Date();

  const worksheet = workbook.addWorksheet("Adviser Appointments", {
    views: [{ state: "frozen", ySplit: 1 }],
  });
  worksheet.columns = [
    { header: "ADVISER NAME", key: "name", width: 36 },
    { header: "APPOINTMENT STATUS", key: "appointmentStatus", width: 24 },
    { header: "DATE OF APPOINTMENT", key: "appointmentDate", width: 24 },
    { header: "EMAIL", key: "email", width: 40 },
  ];

  const asOf = dayjs();
  advisers
    .map((adviser) => {
      const firstName = adviser?.preferredName || adviser?.firstName || "";
      const name = [firstName, adviser?.lastName].filter(Boolean).join(" ").trim();
      const appointmentDate = toAppointmentDate(
        adviser?.dateAppointed,
      );
      return {
        name: name || adviser?.email || adviser?.id || "",
        appointmentStatus: adviser?.isAppointed === false ? "Unappointed / Leaver" : "Appointed",
        appointmentDate: appointmentDate || (typeof adviser?.dateAppointed === "string" ? adviser.dateAppointed : null),
        email: adviser?.email || "",
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }))
    .forEach((row) => worksheet.addRow(row));

  worksheet.getColumn("appointmentDate").numFmt = "dd/mm/yyyy";
  worksheet.autoFilter = "A1:D1";
  worksheet.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
  worksheet.getRow(1).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF081E56" },
  };
  worksheet.getRow(1).alignment = { vertical: "middle", horizontal: "center" };
  worksheet.getRow(1).border = {
    bottom: { style: "medium", color: { argb: "FF9EB25D" } },
  };
  worksheet.getRow(1).height = 26;
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber > 1 && rowNumber % 2 === 0) {
      row.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE9EBF8" },
      };
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  return {
    blob: new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename: `Adviser Appointments - ${asOf.format("DD-MM-YYYY")}.xlsx`,
  };
}

